import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M106.479 60.895a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M91.5 11.799a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M6.566 58.207a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M105.058 20.164a1.5 1.5 0 0 1 0 2.121l-9.994 9.994a1.5 1.5 0 1 1-2.122-2.121l9.994-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M92.942 20.164a1.5 1.5 0 0 1 2.122 0l9.994 9.994a1.501 1.501 0 0 1-2.122 2.121l-9.994-9.994a1.5 1.5 0 0 1 0-2.121M24.5 94.163a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 1 1-3 0V95.663a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M15.934 102.729a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H17.434a1.5 1.5 0 0 1-1.5-1.5M38.338 16h39.324999999999996C80.611 16 83 18.408 83 21.38v72.69800000000001c0 3.27-2.63 5.922-5.875 5.922H38.338C35.39 100 33 97.59 33 94.62V21.38c0-2.972 2.39-5.38 5.337-5.38"
      clipRule="evenodd"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M42 90.25A2.25 2.25 0 0 1 44.25 88h26.503a2.25 2.25 0 0 1 0 4.5H44.25A2.25 2.25 0 0 1 42 90.25"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M58.793 42.659a2.25 2.25 0 0 1 0 3.182L46.841 57.793a2.25 2.25 0 1 1-3.182-3.182l11.952-11.952a2.25 2.25 0 0 1 3.182 0M73.255 59.374a2.25 2.25 0 0 1 0 3.182L61.303 74.508a2.25 2.25 0 0 1-3.182-3.182l11.952-11.952a2.25 2.25 0 0 1 3.182 0M71.791 44.877a2.25 2.25 0 0 1 0 3.182L47.107 72.743a2.25 2.25 0 0 1-3.182-3.182L68.61 44.877a2.25 2.25 0 0 1 3.182 0"
      clipRule="evenodd"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M50 26.25c0-1.243 1.051-2.25 2.348-2.25h11.304C64.949 24 66 25.007 66 26.25s-1.051 2.25-2.348 2.25H52.348C51.051 28.5 50 27.493 50 26.25"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconMobileInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconMobileInverted);
export default Memo;
